var map = {
	"./docline/favicon.png": "1b69",
	"./docline/login-background-bk.png": "4a44",
	"./docline/login-background.png": "28cb",
	"./docline/logo-primary.png": "bfa4",
	"./docline/logo-secondary.png": "ca02",
	"./mfsalud/favicon.png": "9df6",
	"./mfsalud/logo-primary.png": "f2fb",
	"./mfsalud/logo-secondary.png": "3683"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6bbc";